import { standardQuerySerializer } from '../api/serializers';
import { applyQueryConfig, ServiceHandler } from '../utils';
import { fetchNaicsCodesParamsMapping } from './naincsServiceMappings';

const fetchNaicsCodesHandler = ServiceHandler({
  url: '/api/account/v1/naics/search',
  paramsSerializer: (params) =>
    standardQuerySerializer(
      applyQueryConfig(fetchNaicsCodesParamsMapping, params)
    ),
});
export const fetchNaicsCodes = (params: Record<string, unknown> = {}) =>
  fetchNaicsCodesHandler({ params });

const createNaicsCodesHandler = ServiceHandler({
  url: '/api/account/v1/naics',
  method: 'post',
});
export const createNaicsCodes = (
  _params: Record<string, unknown> = {},
  data?: unknown
) => createNaicsCodesHandler({ data });

const updateNaicsCodesHandler = ServiceHandler({
  url: '/api/account/v1/naics/:id',
  method: 'put',
});
export const updateNaicsCodes = (
  params: { id?: string | number } = {},
  data?: unknown
) => updateNaicsCodesHandler(params.id, { data });

const deleteNaicsCodeHandler = ServiceHandler({
  url: '/api/account/v1/naics/:id',
  method: 'delete',
});
export const deleteNaicsCode = ({ id }: { id: string | number }) =>
  deleteNaicsCodeHandler(id);
